import React from 'react';
import { any, equals, props } from 'ramda';
import Translate from 'react-translate-component';

const checkHappen = any(equals(true));
const translateError = (error) => error ? (
    error.translate ? <Translate content={error.translate} with={error.params} /> : error
) : undefined;

const Error = (componentProps) => {
    let { error, warning, events = [], defaultEvents, className } = componentProps;
    error = translateError(error);

    const isEventsHappened = checkHappen(props([...events, ...defaultEvents], componentProps));
    const text = error || warning;

    return (
        <div className='input-error'>
            { isEventsHappened && text && (
                <div className={className}>
                    {text}
                </div>
            )}
        </div>
    );
}

Error.defaultProps = {
    defaultEvents: ['submitFailed']
}

export default Error;
